<template>
  <div class="cascaderArea">
    <el-select
      v-model="select.country"
      placeholder="请选择国家"
      @change="changeCountry"
      class="middle-select"
    >
      <el-option value label="不限"></el-option>
      <el-option
        v-for="item in list.countrys"
        :key="item.id"
        :label="item.name"
        :value="item.name"
      ></el-option>
    </el-select>

    <el-select
      v-model="select.province"
      placeholder="请选择省份"
      @change="changeProvince"
      class="middle-select"
    >
      <el-option value label="不限"></el-option>
      <el-option
        v-for="item in list.provinces"
        :key="item.id"
        :label="item.name"
        :value="item.name"
      ></el-option>
    </el-select>
    <el-select
      v-model="select.city"
      placeholder="请选择地区"
      @change="changeCity"
      class="middle-select"
    >
      <el-option value label="不限"></el-option>
      <el-option
        v-for="item in list.citys"
        :key="item.id"
        :label="item.name"
        :value="item.name"
      ></el-option>
    </el-select>
  </div>
</template>

<script>
import { getCityAll } from "@/api/common";
export default {
  props: {
    country: {
      type: String
    },
    province: {
      type: String
    },
    city: {
      type: String
    }
  },
  data() {
    return {
      list: {
        areaData: [],
        countrys: [],
        provinces: [],
        citys: []
      },
      select: {
        country: null,
        province: null,
        city: null
      }
    };
  },
  created() {
    // this.search();

    getCityAll().then(res => {

    }).catch(err => {
    });
  },
  methods: {
    async search() {
      try {
        this.areaData = sessionStorage.getItem("area");

        if (!this.areaData) {
          const { data: res } = await getCityAll();

          sessionStorage.setItem("area", JSON.stringify(res));
        }

        this.areaData = JSON.parse(sessionStorage.getItem("area"));
        

        // if (this.country) {
        //   this.select.country = this.country;
        //   this.changeCountry(this.country);
        // }

        // if (this.province) {
        //   this.select.province = this.province;
        //   this.changeProvince(this.province);
        // }

        // if (this.city) {
        //   this.select.city = this.city;
        //   this.changeCity(this.city);
        // }
      } catch (err) {
        console.error({
          component: "CascaderAreaEnter",
          line: 109,
          error: err
        });
      }
    },
    changeCountry(val) {
      this.list.provinces = [];
      this.list.citys = [];
      this.list.countrys.forEach(item => {
        if (item.name === val) {
          this.list.provinces = item.cityResults;
        }
      });

      this.select.province = "";

      this.select.city = "";

      this.$emit("searchArae", { ...this.select });
    },
    changeProvince(val) {
      this.list.citys = [];

      this.list.provinces.forEach(item => {
        if (item.name === val) {
          this.list.citys = item.cityResults;
        }
      });

      this.select.city = "";

      this.$emit("searchArae", { ...this.select });
    },
    changeCity(val) {
      this.$emit("searchArae", { ...this.select });
    },
    clear() {
      this.select = {
        country: "",
        province: "",
        city: ""
      };
    }
  }
};
</script>

<style lang="less" scoped>
.cascaderArea {
  .el-select {
    margin-right: 10px;
  }
}
</style>
